module.exports = __webpack_public_path__ + "img/2024big20.b7417952.png";